import React from 'react'
import * as Sentry from '@sentry/browser'
export default () => (
  <span
    style={{
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: 80,
      height: 80,
      cursor: 'pointer'
    }}
    onClick={() => {
      if (
        process.env.NODE_ENV !== 'production' &&
        process.env.REACT_APP_NO_SENTRY
      ) {
        console.error('REACT_APP_NO_SENTRY set')
        return
      }
      if (!Sentry.lastEventId()) Sentry.captureMessage('Bug Button Triggered')
      Sentry.showReportDialog()
    }}
    aria-label="crash"
    role="img"
  />
)
